module.exports = __webpack_public_path__ + "img/cash_nl5.162ee670.png";